import type { ZodErrorMap, ZodIssueCode } from 'zod';
import { tx } from './sourceTranslator';

/** Resolve schema messages when an issue is emitted, including for stable exported schemas. */
export function localizedZodErrorMap(messages: Partial<Record<ZodIssueCode, string>>): ZodErrorMap {
  return (issue, context) => ({
    message: messages[issue.code] ? tx(messages[issue.code]!) : context.defaultError,
  });
}
